import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Your Channel Network";
const DEFAULT_OG = "/brand/ycn-logo.png";

/**
 * Reusable SEO tags for each route.
 * - title      : "Page Name | Your Channel Network"
 * - description: unique per page
 * - path       : canonical path (e.g. "/movies")
 * - image      : OG image URL (defaults to YCN logo)
 * - noindex    : optional
 */
export default function SEO({ title, description, path = "", image = DEFAULT_OG, noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Your Story. Your Voice. Your Channel.`;
  const canonical = `https://yourchannelnetwork.com${path || ""}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,follow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
